/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Remember_MeInputs */

const en_auth__remember_me = /** @type {(inputs: Auth__Remember_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remember for 30 days`)
};

/**
* | output |
* | --- |
* | "Remember for 30 days" |
*
* @param {Auth__Remember_MeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__remember_me = /** @type {((inputs?: Auth__Remember_MeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Remember_MeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__remember_me(inputs)
});